import React, { Component } from "react";
import "./BookingApp.css";
import Select from "react-select";

const customStyles = {
  control: base => ({
    ...base,
    borderColor: "#ccc",
    boxShadow: "0 0 0 1 #ccc",
    "&:hover": {
      borderColor: "#ccc"
    }
  })
};

export default class BookingApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.bookingApp.open,
      isCheckedAvailability: this.props.isCheckedAvailability || false
    };

    if (!this.props.bookingApp.rooms) {
      this.props.bookingApp.rooms = 1;
      this.props.bookingApp.adults = 1;
      this.props.bookingApp.children = 0;
    }

    this.selectProperty = event => {
      this.props.bookingApp.selectedPid = event;
      this.forceUpdate();
      localStorage.setItem(
        this.props.bookingApp.lStore.PROPERTYID,
        event.value
      );
      localStorage.setItem(
        this.props.bookingApp.lStore.PROPERTYNAME,
        event.label
      );

      this.props.bookingApp.callbacks.getStore().dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/update",
          value: {
            pid: event.value,
            pname: event.label,
            page_url: this.props.parent_location
          }
        }
      });
      this.setState({ active: false });
    };
    this.toggle = this.toggle.bind(this);
    this.sendDates = this.sendDates.bind(this);
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (
      this.props.room_app &&
      this.props.room_app.reinit &&
      this.state.active !== true
    ) {
      this.setState({ active: this.props.room_app.reinit });
      this.setState({ open: this.props.room_app.reinit });
    }
  };

  //  FIXME:
  // This EventListener is to ensure that the pop up window closes when the user enters the input box at the bottom. But it will affect the input in the pop up window.
  //  FIXME:
  // componentDidMount = () => {
  //   window.addEventListener("input", this.close_pop.bind(this), false);
  // };

  toggle() {
    const { active } = this.state;
    this.setState({ active: !active });
    this.setState({ open: !active });
    this.props.close_pop();
  }
  close_pop(event) {
    if (this.state.active) {
      this.setState({ active: false });
      this.setState({ open: false });
      this.props.close_pop();
    }
  }

  sendDates() {
    var hotel = {};
    if (this.props.bookingApp.selectedPid) {
      hotel = this.state.properties.find(
        property => property.pid === this.props.bookingApp.selectedPid
      );
    }
    this.props.bookingApp.callbacks.getStore().dispatch({
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "webchat/booking-details",
        value: {
          hotel: hotel.name,
          dates: this.props.bookingApp.dates,
          rooms: this.props.bookingApp.rooms,
          adults: this.props.bookingApp.adults,
          kids: this.props.bookingApp.kids
        }
      }
    });
    this.close();
  }

  setCheckAvailability = isCheckedAvailability => {
    this.setState({ isCheckedAvailability: isCheckedAvailability });
  };

  render() {
    var { room_app } = this.props;
    var { selectedPid } = this.props.bookingApp;

    var hotel = "";
    if (selectedPid) {
      hotel = this.props.bookingApp.properties.find(
        property => property.pid === selectedPid
      );
    }

    return (
      <div className="chat_popup booking_popup" style={{ zIndex: 3 }}>
        <div
          className={`popup-slider ${this.state.active || (room_app && room_app.reinit)
              ? "slideIn"
              : "slideOut"
            }`}
          style={{ marginLeft: "auto", marginRight: "auto" }}
        >
          <div className="w-100">
            {this.props.bookingApp.properties && (
              <Select
                options={this.props.bookingApp.properties}
                onChange={this.selectProperty}
                value={this.props.bookingApp.selectedPid}
                placeholder="Select Property..."
                styles={customStyles}
              />
            )}
          </div>
        </div>
        {(room_app && room_app.details.length > 0) ||
          this.props.bookingApp.properties !== undefined ? (
          <button type="button"
            aria-label="Close icon"
            className="booking_close_divider list-button"
            style={{
              backgroundColor: this.props.botSettings.colours.header
            }}
            onClick={this.toggle}
          >
            {this.state.active ? (
              <span className="glyphicon glyphicon-menu-up booking_close_divider_icon" />
            ) : (
              <span className="glyphicon glyphicon-menu-down booking_close_divider_icon" />
            )}
          </button>
        ) : null}
      </div>
    );
  }
}
